import get from 'lodash/get';
import {
  getDateCustomFormat,
  US_LONG_AM_PM_UI,
  formatDateToSave,
  setDateToSave
} from './dates';

const delay = async ms => {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
};

export const keepNumberBetweenRange = ({ min = 0, max = 100, value }) =>
  Math.min(Math.max(min, +value), max);

export const getFleetsSideId = fleets => {
  const fleetArray = [];
  fleets.forEach(element => {
    if (element.indexOf('AB') > -1) {
      const fleetAux = element.replace('AB', '');
      fleetArray.push(`${fleetAux}A`);
      fleetArray.push(`${fleetAux}B`);
    } else {
      fleetArray.push(element);
    }
  });
  return fleetArray;
};

export const timeConvert = n => {
  const num = n;
  const hours = num / 60;
  const rhours = Math.floor(hours);
  const minutes = (hours - rhours) * 60;
  const rminutes = Math.round(minutes);
  return [rhours, rminutes];
};

export const shouldRefresh = auth => {
  if (auth?.isOidcClient) {
    return;
  }
  const expirationTimeMillis = get(auth, 'tokenPayload.exp', 0);
  const currentTimeMillis = new Date().getTime() / 1000;
  const needRefresh = expirationTimeMillis <= currentTimeMillis;
  return needRefresh;
};

export const shouldRefreshV3 = auth => {
  if (!auth?.tokenPayload?.exp) {
    return {
      expiresInSec: 0,
      refreshTime: 0,
      expDate: null,
      timeUntilExpiration: true,
      needRefresh: false
    };
  }

  const buffer = 60;
  const now = Math.floor(Date.now() / 1000);
  const exp = auth.tokenPayload.exp;
  const iat = auth.tokenPayload.iat;
  const expiresInSec = exp - now;
  const refreshTime = Math.max(expiresInSec - buffer, 0) * 1000;

  const expDate = new Date(exp * 1000);
  const issuedAtDate = new Date(iat * 1000);

  const needRefresh = now >= exp - buffer;

  return needRefresh;
};

export const removeMultipleArrElm = (arr, elements) => {
  let newArr = [...arr];
  elements.forEach(el => {
    newArr = newArr.filter(arrEl => arrEl !== el);
  });
  return newArr;
};

export const formatDate = occurredAt => {
  let selectedDate = new Date();
  if (occurredAt) {
    selectedDate = getDateCustomFormat(
      occurredAt,
      US_LONG_AM_PM_UI,
      formatDateToSave
    );
  } else {
    selectedDate = setDateToSave();
  }
  return selectedDate;
};

export const fixDecimals = (value, decimalsLength) => {
  if (value && value?.includes('.')) {
    return value.toString().split('.')[1].length >= decimalsLength
      ? parseFloat(value).toFixed(decimalsLength)
      : value;
  }
  return value;
};

export const numberWithCommas = x => {
  const parts = x.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

export const ConditionalWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;

export const splitObject = obj => {
  const keys = Object.keys(obj);
  const mid = Math.ceil(keys.length / 2);

  const obj1 = {};
  const obj2 = {};

  keys.forEach((key, index) => {
    if (index < mid) {
      obj1[key] = obj[key];
    } else {
      obj2[key] = obj[key];
    }
  });

  return [obj1, obj2];
};

export const isNumericString = str =>
  typeof str === 'string' &&
  !Number.isNaN(str) &&
  !Number.isNaN(parseFloat(str));

export const getPlatform = () => {
  // Check for web environment
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    return 'web';
  }

  return 'mobile';
};

/**
 * Query param `username` for driver-scoped APIs (e.g. driver-loads).
 * Uses hydrated profile when present; otherwise JWT claims (aligned with auth refresh).
 */
export const getDriverUsernameForApi = (auth, usersState) => {
  const fromProfile = get(usersState, 'driverUser.username');
  if (fromProfile) {
    return fromProfile;
  }
  return (
    get(auth, 'tokenPayload.username') ||
    get(auth, 'tokenPayload.email') ||
    get(auth, ['tokenPayload', 'cognito:username'])
  );
};

export default delay;
